import { HttpClient } from "@angular/common/http";
import { AppConfigUtil } from "../../utils/app-config.util";
import { AppUtil } from "../../utils/app.util";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class AppConfigService {
    constructor(http) {
        this.http = http;
    }
    fetchApplicationConfig(_propertyResourceUrl, _propertyResourceUri) {
        return this.http.get(_propertyResourceUrl + _propertyResourceUri);
    }
    load(_propertyResourceUrl, _propertyResourceUri) {
        return new Promise((resolve, reject) => {
            if (_propertyResourceUri &&
                !AppConfigService.alreadyLoadedModuleConfig.has(_propertyResourceUri)) {
                this.fetchApplicationConfig(_propertyResourceUrl, _propertyResourceUri).subscribe((appConfigResponse) => {
                    if (appConfigResponse) {
                        const appConfigResponsePrev = AppConfigUtil.getProperties();
                        const appConfigResponseMerged = AppUtil.mergeSourceObjects(appConfigResponsePrev, appConfigResponse);
                        AppConfigUtil.setProperties(appConfigResponseMerged);
                        AppConfigService.alreadyLoadedModuleConfig.add(_propertyResourceUri);
                    }
                    AppUtil.log("AppConfigService : load() : App Config loaded :: AppConfigUtil.getProperties() :: ===> %o ", AppConfigUtil.getProperties());
                    return resolve(true);
                }, (error) => {
                    AppUtil.error("**************AppConfigService : load() : App Config not loaded. %o not found **************", _propertyResourceUrl + _propertyResourceUri);
                    return resolve(true);
                });
            }
            else {
                return resolve(true);
            }
        });
    }
}
AppConfigService.alreadyLoadedModuleConfig = new Set();
AppConfigService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AppConfigService_Factory() { return new AppConfigService(i0.ɵɵinject(i1.HttpClient)); }, token: AppConfigService, providedIn: "root" });
